import React, {Component} from 'react'
import { Link } from 'react-router-dom';

import {
  Icon,
  Menu,
  Image
} from 'semantic-ui-react'
import Logo from '../assets/images/Logo.png'
import LogoMobile from '../assets/images/Logo-Mobile.png'

export default class Navbar extends Component {
    state = {
        activeItem: window.location.pathname.replace('/', '')
    }

    changeActive = (e, {name} = e.target) => {
        if (name === 'home') {
            name = ''
        }
        this.setState( {activeItem: name} )
    }

    render() {
        const {activeItem} = this.state

        return (
            <div className="navbar">
               <Menu.Item
                    as={Link}
                    to="/"
                    name='home'
                    onClick={this.changeActive}
                >
                    <Image className="logo" src={Logo} />
                </Menu.Item>
                <Menu.Item
                    as={Link}
                    to="/guardians"
                    name='guardians'
                    active={activeItem === 'guardians'}
                    onClick={this.changeActive}
                >
                    <Icon size="big" name='users' />
                    <span className="link-text">Guardians</span>
                </Menu.Item>
                <Menu.Item
                    as={Link}
                    to='/data'
                    name='data'
                    active={activeItem === 'data'}
                    onClick={this.changeActive}
                >
                    <Icon size="big" name='diamond' />
                    <span className="link-text">Data</span>
                </Menu.Item>
                <Menu.Item
                    as={Link}
                    to="/"
                    name='home'
                    onClick={this.changeActive}
                    className="mobile"
                >
                    <Image className="logoMobile" src={LogoMobile} />
                </Menu.Item>
                <Menu.Item
                    as={Link}
                    to='/guides'
                    name='guides'
                    active={activeItem === 'guides'}
                    onClick={this.changeActive}
                >
                    <Icon size="big" name='book' />
                    <span className="link-text">Guides</span>
                </Menu.Item>
                <Menu.Item
                    as={Link}
                    to='/videos'
                    name='videos'
                    active={activeItem === 'videos'}
                    onClick={this.changeActive}
                >
                    <Icon size="big" name='video play' />
                    <span className="link-text">Videos</span>
                </Menu.Item>
            </div>
        );
    }

}
